// External libraries

// Internal imports
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslations from './locales/en.json';
import taTranslations from './locales/ta.json';

const configureTamilFonts = () => {
  const style = document.createElement('style');
  style.textContent = `
    @import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Tamil:wght@300;400;500;600;700&display=swap');

    .tamil-text {
      font-family: 'Noto Sans Tamil', 'Lohit Tamil', 'Tamil MN', sans-serif;
      line-height: 1.6;
      letter-spacing: 0.02em;
    }

    .tamil-heading {
      font-family: 'Noto Sans Tamil', 'Lohit Tamil', 'Tamil MN', sans-serif;
      font-weight: 600;
      line-height: 1.4;
    }

    .tamil-ui {
      font-family: 'Noto Sans Tamil', 'Lohit Tamil', 'Tamil MN', system-ui, sans-serif;
      font-size: 0.95em;
      line-height: 1.5;
    }

    /* Animation delays for loading states */
    .animation-delay-150 {
      animation-delay: 150ms;
    }

    .animation-delay-200 {
      animation-delay: 200ms;
    }

    .animation-delay-400 {
      animation-delay: 400ms;
    }

    /* RTL support for Tamil */
    [dir="rtl"] .tamil-text,
    [dir="rtl"] .tamil-heading,
    [dir="rtl"] .tamil-ui {
      text-align: right;
      unicode-bidi: plaintext;
    }

    /* Mobile optimization for Tamil text */
    @media (max-width: 768px) {
      .tamil-text {
        font-size: 0.9em;
        line-height: 1.7;
      }

      .tamil-heading {
        font-size: 0.95em;
        line-height: 1.5;
      }
    }

    /* Enhanced glassmorphism effects for Tamil content */
    .tamil-glass {
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
    }

    /* Enhanced button animations */
    .tamil-button {
      background: linear-gradient(135deg, #9333ea 0%, #3b82f6 100%);
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .tamil-button:hover {
      transform: translateY(-2px);
      box-shadow: 0 10px 25px rgba(147, 51, 234, 0.3);
    }
  `;
  document.head.appendChild(style);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'voterVerify_language',
    },

    resources: {
      en: {
        translation: enTranslations
      },
      ta: {
        translation: taTranslations
      }
    },

    react: {
      useSuspense: false,
    }
  });

// Initialize Tamil fonts when i18n is ready
i18n.on('initialized', () => {
  configureTamilFonts();
});

// Configure language-specific settings
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;

  // Set text direction for Tamil (can be adjusted based on user preference)
  if (lng === 'ta') {
    document.documentElement.dir = 'ltr'; // Tamil is typically written left-to-right
    document.body.classList.add('tamil-text');
  } else {
    document.documentElement.dir = 'ltr';
    document.body.classList.remove('tamil-text');
  }
});

export default i18n;